import axios from 'axios';

axios.interceptors.response.use(undefined, function axiosRetryInterceptor(err) {
    
    let error = {status: 0, message: 'Error desconocido'}
    if (err.message === 'Network Error' && !err.request){
        error.status = 0;
        error.message = 'Error de red';
    }
    else if(err.request){
        error.status = err.request.status;
        if (err.request.status === 401){
            error.message = 'Credenciales inválidas';
        }
        else if (err.request.status === 403){
            error.message = 'No autorizado';
        }
        else if (err.request.status === 0){
            error.message = 'Error en la red';
        }
        else{
            error.message = err.message;
        }
        error.response = err.response;
    }
    
    return Promise.reject(error);
  });

export default class ApiLoad {
    
    
    static auth = (url, credentials) => {

        return new Promise((resolve, reject) => {
            
            axios.post(url, credentials).then((response) => {
                resolve(response.data);
            })
            .catch(function (error) {
                reject(error);
            });
            
        });
    }

    static getWithBasic = (url, data,  basic) => {

        return new Promise((resolve, reject) => {
            
            axios.get(url, data, basic).then((response) => {
                resolve(response.data);
            })
            .catch(function (error) {
                reject(error);
            });
            
        });
    }

    static requestWithBearer = (url, method='post', data = {},  token = null, isFile = false) => {

        return new Promise((resolve, reject) => {
            
            axios.request({
                url
                ,method
                ,data: method === 'post' ? (isFile ? data : JSON.stringify(data) ) : ''
                ,params: method === 'get' ? data : ''
                ,headers: {
                    "Authorization": `Bearer ${token}`
                    ,'content-type': isFile ? 'multipart/form-data' : 'application/json'
                    ,'accept': 'application/json'
                }
            }).then((response) => {
                resolve(response.data);
            })
            .catch(function (error) {
                reject(error);
            });
            
        });
    }

}

